import React from 'react'

export default function PotatoHuntOnStartAnimation({imagePath,imageName, altText, isOnStart}) {

	return (
		<>
			<div className={`on-start-animation fade-box ${!isOnStart ? 'fade-out' : ''}`}>
				<img src={imagePath + imageName} alt={altText}/>
			</div>
		</>
	)
}
